export default __webpack_public_path__ + "static/media/sha256-phones.dd75ddf4.csv";